import template from './form.html';
import { FormActions } from 'core/services/form';
import disponibilidadesI18N from 'i18n/disponibilidades/es.json';
import commonI18N from 'i18n/common/es.json';
import { pad } from 'core/util';
import { formatErrorMessage } from 'core/util';


export let DisponibilidadFormComponent = {
  templateUrl: template,
  selector: 'disponibilidadForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(disponibilidadesI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$scope',
  '$transitions'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout,
  $scope, $transitions) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.loadEmpleados = loadEmpleados.bind(this);
  this.renderEmpleado = renderEmpleado.bind(this);
  this.checkState = checkState.bind(this);
  let unsubscribe;
  this.sliderOptionsFull = {
    floor: 0,
    ceil: 24,
    step: 1,
    minRange: 0,
    maxRange: 24,
    noSwitching: true,
    translate(value) {
      return `${~~value}:${'00'}`;
      //return `${~~(value/2)}:${value%2 ? '30' : '00'}`;
    }
  };

  this.sliderOptions = [{
    floor: 0,
    ceil: 24,
    step: 1,
    minRange: 0,
    maxRange: 24,
    noSwitching: true,
    showTicks: true,
    translate(value) {
      return `${pad(~~(value/2), 2)}:${value%2 ? '30' : '00'}`;
    }
  }, {
    floor: 24,
    ceil: 36,
    step: 1,
    minRange: 0,
    maxRange: 12,
    noSwitching: true,
    showTicks: true,
    translate(value) {
      return `${pad(~~(value/2), 2)}:${value%2 ? '30' : '00'}`;
    }
  }, {
    floor: 36,
    ceil: 48,
    step: 1,
    minRange: 0,
    maxRange: 12,
    noSwitching: true,
    showTicks: true,
    translate(value) {
      return `${pad(~~(value/2), 2)}:${value%2 ? '30' : '00'}`;
    }
  }];

  this.localModel = {};

  this.dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabados', 'domingos'];
  this.diasCaps = this.dias.map(_.capitalize);
  let transitionHook;

  for (let dia of this.dias) {
    this.localModel[dia] = {};
    this.localModel[dia].habilitado = false;
    this.localModel[dia].open = false;
    this.localModel[dia].horarios = [
      {
        inicio: 16,
        fin: 24
      }, {
        inicio: 24,
        fin: 36
      }, {
        inicio: 36,
        fin: 40
      }
    ];
  }

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
    transitionHook();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.props = { save: this.save };

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver disponibilidad'] : this.translations['Editar disponibilidad'];
      this.formEdit('disponibilidades', $stateParams.uid);
      this.isEdit = true;
      this.disponibilidadId = parseInt($stateParams.uid);
    } else {
      this.title = this.translations['Nueva disponibilidad'];
      this.form();
    }
    this.checkState($state.current.name);
    transitionHook = $transitions.onBefore({}, (transition) => {
      this.checkState(transition.to().name);
    });
  };

  this.$postLink = () => {
    $timeout(function() {
      $scope.$broadcast('rzSliderForceRender');
    });
  };


  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    let model = state.form.model;

    if (state.form.model.id && !this.parsed) {
      this.parsed = true;
      let dia;
      this.localModel = {};
      for (let diaCap of this.diasCaps) {
        dia = diaCap.toLowerCase();
        this.localModel[dia] = {};
        this.localModel[dia].habilitado = model[`habilitado${diaCap}`];
        this.localModel[dia].horarios = model[`horarios${diaCap}`];
        // for (let horario of model[`horarios${diaCap}`]) {
        //   this.localModel[dia].horarios.push({
        //     inicio: parseInt(horario.inicio.replace(':00', '')),
        //     fin: parseInt(horario.fin.replace(':00', ''))
        //   });
        // }
      }
    }
    return { form: state.form, model };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.disponibilidades.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.disponibilidades.list');
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);

    let dia;
    for (let diaCap of this.diasCaps) {
      dia = diaCap.toLowerCase();
      data[`habilitado${diaCap}`] = this.localModel[dia].habilitado;
      data[`horarios${diaCap}`] = this.localModel[dia].horarios;
    }
    this.save('disponibilidades', data);
  }

  /**
   * Se encarga de traer el backend la lista de empleados a mostrar.
   * 
   * @param {string} query 
   */
  function loadEmpleados(query) {
    let filter = Filter.path('disponibilidad.id').isNull()
      .and(Filter.path('tipoEmpleado.value').eq('Especialista'))
      .and(Filter.path('activo').eq(true));

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('estadoCivil.value').like(query))
        .or(Filter.path('telefono').like(query)));
    }
    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderEmpleado(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  function checkState(name) {
    this.isExcepcionFormState = name === 'home.disponibilidades.uid.edit.excepciones.new' ||
      name === 'home.disponibilidades.uid.edit.excepciones.eid.edit' ||
      name === 'home.disponibilidades.uid.edit.excepciones.eid.view';
  }
}


// WEBPACK FOOTER //
// ./src/components/disponibilidades/form/form.component.js